import { render, staticRenderFns } from "./NestableTree.vue?vue&type=template&id=70cd97ef&scoped=true"
import script from "./NestableTree.vue?vue&type=script&lang=js"
export * from "./NestableTree.vue?vue&type=script&lang=js"
import style0 from "./NestableTree.vue?vue&type=style&index=0&id=70cd97ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd97ef",
  null
  
)

export default component.exports